<template>
  <div class="container invoice-table">
    <p class="float-left text-danger" style="margin-top: 8px; margin-left: 6px">
      <strong>{{ message }}</strong>
    </p>
    <table class="table table-sm text-left">
      <thead>
      <tr>
        <th>№</th>
        <th>ID</th>
        <th>Дата</th>
        <th>Статус</th>
        <th>Комментарий</th>
        <th>Email status</th>
        <th></th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(item, i) in versions">
        <td>{{ i + 1 }}</td>
        <td>{{ item.ID }}</td>
        <td class="text-nowrap">{{ item.DateCreated }}</td>
        <td>

          <span
              v-if="!item.isStatusCanBeChanged">
            {{ statusList[item.Status] }}
          </span>
          <span
              v-if="item.isStatusCanBeChanged">
             <select v-model="item.Status"
                     @change="updateStatus(item.ID, item.Status)">
                <option v-for="st in invoiceStatusList" :value="st.id">{{ st.name }}</option>
              </select>
          </span>

        </td>
        <td>{{ item.Comment }}</td>
        <td>{{ item.EmailSendStatus }}</td>
        <td>
          <button v-if="isEmailActive && item.Status == 2"
                  class="btn my-2 my-sm-0 float-left btn-outline-primary" style="width: 250px; margin-right: 10px"
                  @click="sendByEmail(item.ID)"
                  :disabled="isSendDisabled">
            Email to {{ invoice.contract.email }}
          </button>
          <button v-if="isEdiActive && item.isEdiAvtive"
                  class="btn my-2 my-sm-0 float-left btn-outline-primary" style="width: 150px; margin-right: 10px"
                  @click="sendByEdi(item.ID)"
                  :disabled="isSendDisabled">
            <span v-if="!isSendDisabled">ЭДО</span>
            <span v-if="isSendDisabled" class="spinner-border spinner-border-sm" role="status"
                  aria-hidden="true">
                </span>
          </button>
          <button v-if="isPostActive && item.Status == 2"
                  class="btn my-2 my-sm-0 float-left btn-outline-primary" style="width: 150px; margin-right: 10px"
                  @click="sendByPost(item.ID)"
                  :disabled="isSendDisabled">
            Почта
          </button>
        </td>
        <td>
          <div v-if="item.DigitalID !== ''">

          </div>
        </td>
      </tr>
      </tbody>
    </table>
  </div>

</template>

<script>
import axios from 'axios';

export default {
  name: 'InvoiceVersions',
  data() {
    return {
      doc_id: null,
      invoice: null,
      message: ' ',
      sendDisabled: false,
      emailActive: false,
      ediActive: false,
      postActive: false,
      statusEdi: "",
      versions: [],
      portalUrl: {
        "ru": "wowworks.ru",
        "by": "wowworks.by",
        "de": "de.wowworks.org",
      },
      statusList: {
        1: "Подготовлен",
        2: "Создан",
        3: "На согласовании",
        4: "Согласован",
        5: "Не согласован",
        6: "Отправлен",
        7: "Подписан",
        8: "Отклонен",
        9: "Сторнирован",
      },
      invoiceStatusList: [
        {id: 1, name: 'Подготовлен', is_final: false},
        {id: 2, name: 'Создан', is_final: false},
        {id: 3, name: 'На согласовании', is_final: false},
        {id: 4, name: 'Согласован', is_final: false},
        {id: 5, name: 'Не согласован', is_final: true},
        {id: 6, name: 'Отправлен', is_final: false},
        {id: 7, name: 'Подписан', is_final: true},
        {id: 8, name: 'Отклонен', is_final: true},
        {id: 9, name: 'Сторнирован', is_final: true},
      ],
    };
  },
  computed: {
    isSendDisabled() {
      return this.sendDisabled || !this.$store.getters.isDocEditAllowed;
    },
    isEmailActive() {
      return this.emailActive;
    },
    isEdiActive() {
      return this.ediActive;
    },
    isPostActive() {
      return this.postActive;
    },
  },

  methods: {

    load() {
      axios.get(`/docs/${this.invoice.id}/versions`)
          .then((res) => {
            console.log(res.data);

            var items = res.data;

            items.forEach(item => {
              item.DateCreated = new Date(item.DateCreated).toISOString().split("T")[0];
              item.isStatusCanBeChanged = !((item.Status === 2 && this.invoice.country_id !== 'ru') || item.Status === 1 || item.Status === 5 || item.Status === 7 || item.Status === 9 || this.invoice.type_id === 4) && (this.invoice.contract.manual_invoice_status);
              item.isEdiAvtive = (item.Status === 2 || item.Status === 3 || item.Status === 4) && !this.invoice.cancelled;

            });

            this.versions = items;


          })
          .catch(error => console.log(error));


    },

    sendByEmail(id) {

      this.sendDisabled = true;
      axios.get(`/invoice-version/` + id + `/send-by-email`)
          .then((res) => {
            console.log(res.data);
          })
          .catch(error => {
            console.log(error);
            this.message = (typeof error.response !== 'undefined') ? error.response.data : error.message;
          })
          .finally(() => {
            this.load();
          });

    },

    sendByEdi(id) {

      this.sendDisabled = true;
      axios.get(`/invoice-version/` + id + `/send-by-edi`)
          .then((res) => {
            console.log(res.data);
          })
          .catch(error => {
            console.log(error);
            this.message = (typeof error.response !== 'undefined') ? error.response.data : error.message;
          })
          .finally(() => {
            this.sendDisabled = false;
            this.load();
          });

    },

    sendByPost(id) {

      this.sendDisabled = true;
      axios.get(`/invoice-version/` + id + `/send-by-post`)
          .then((res) => {
            console.log(res.data);
          })
          .catch(error => {
            console.log(error);
            this.message = (typeof error.response !== 'undefined') ? error.response.data : error.message;
          })
          .finally(() => {
            this.load();
          });

    },

    updateStatus(id, status) {

      this.sendDisabled = true;
      axios.post(`/invoice-version/` + id + `/update-status`, status)
          .then((res) => {
            console.log(res.data);
          })
          .catch(error => {
            console.log(error);
            this.message = (typeof error.response !== 'undefined') ? error.response.data : error.message;
          })
          .finally(() => {
            this.load();
          });

    },

  },


  beforeCreate() {

  },

  mounted() {
    this.doc_id = this.$route.params.doc_id;
    axios.defaults.headers.authorization = this.$store.state.token;

    axios.get(`/doc_by_id`, {
      params: {
        invoice_id: this.$route.params.doc_id,
        country_id: this.$route.params.countryID,
      },
    })
        .then((res) => {
          console.log(res.data);
          this.invoice = res.data;

          let riglaBranches = [234, 412];

          if (this.invoice.customer_id === 169) {
            if (riglaBranches.includes(this.invoice.branch_id)) {
              this.invoice.contract.manual_invoice_status = true;
            }
          }

          if (this.invoice.country_id === 'ru') {
            this.ediActive = true;

            if (this.invoice.contract.manual_invoice_status) {
              this.ediActive = false;
            }
          }

          if (this.invoice.country_id === 'de') {

            this.invoice.contract.manual_invoice_status = true;

            if (typeof this.invoice.contract.email !== "undefined" && this.invoice.contract.email !== null && this.invoice.contract.email.length > 0) {
              this.emailActive = true;
            }

            if (this.emailActive === false) {
              if (this.invoice.customer_id !== 823) {
                this.postActive = true;
              }

              //Peter Pane
              if (this.invoice.customer_id === 829) {
                // this.postActive = false;
                this.sendDisabled = true;
              }

              //Гутшрифт
              if (this.invoice.type_id == 3) {
                this.postActive = false;
              }
            }

            if (this.invoice.franchise_id == 8) {
              this.emailActive = false;
              this.postActive = false;
              this.ediActive = true;
            }

            if (this.invoice.cancelled) {
              this.emailActive = false;
              this.postActive = false;
              this.ediActive = false;
            }


          }

          this.load();

        })
        .catch(error => console.log(error));


  },
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.invoice-table {
  font-size: 14px;
}

</style>
